import { COLORS } from "../../../../theme/colors";

export const tenancyChartLines = [
  { dataKey: "building", stroke: COLORS.blue },
  { dataKey: "portfolio", stroke: COLORS.spanishGray },
  { dataKey: "industry", stroke: COLORS.darks[0][100] },
];

export const tenantPaymentBars = [
  { key: "paying", color: COLORS.green },
  { key: "delay", color: COLORS.red },
  { key: "delays", color: COLORS.internationalOrange },
];

export const tenantPaymentReportBars = [
  { key: "paying", color: COLORS.green },
  { key: "two_month", color: COLORS.red },
  { key: "six_month", color: COLORS.internationalOrange },
  { key: "six_year", color: COLORS.barnRed },
  { key: "year", color: COLORS.black },
];

export const comparisonChartData = [
  {
    x: "2022-1",
    industry: 1000,
    building: 1100,
    portfolio: 1200,
    tenant: 1300,
  },
  {
    x: "2022-2",
    industry: 1500,
    building: 1600,
    portfolio: 1800,
    tenant: 2000,
  },
  {
    x: "2022-3",
    industry: 2000,
    building: 2100,
    portfolio: 2300,
    tenant: 2500,
  },
  {
    x: "2022-4",
    industry: 2500,
    building: 2600,
    portfolio: 2800,
    tenant: 3000,
  },
  {
    x: "2022-5",
    industry: 3000,
    building: 3100,
    portfolio: 3300,
    tenant: 3500,
  },
  {
    x: "2022-6",
    industry: 2500,
    building: 2600,
    portfolio: 2800,
    tenant: 3000,
  },
  {
    x: "2022-7",
    industry: 2000,
    building: 2100,
    portfolio: 2300,
    tenant: 2500,
  },
  {
    x: "2022-8",
    industry: 2500,
    building: 2600,
    portfolio: 2800,
    tenant: 3000,
  },
  {
    x: "2022-9",
    industry: 3000,
    building: 3100,
    portfolio: 3300,
    tenant: 3500,
  },
  {
    x: "2022-10",
    industry: 3500,
    building: 3600,
    portfolio: 3800,
    tenant: 4000,
  },
  {
    x: "2022-11",
    industry: 4000,
    building: 4100,
    portfolio: 4300,
    tenant: 4500,
  },
  {
    x: "2022-12",
    industry: 4500,
    building: 4600,
    portfolio: 4800,
    tenant: 5000,
  },
];
